import React from "react";
import { Nav } from "reactstrap";
import { connect } from "react-redux";
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink, withRouter } from 'react-router-dom';

const logoAlt = process.env.REACT_APP_CRAWLER_OWNER + " Crawler";
const ownerLogo = "/owner-logos/" + process.env.REACT_APP_CRAWLER_OWNER + ".png"

class Sidebar extends React.Component {

    //Métodos de ciclo de vida del componente: 
    constructor(props) {
        super(props);

        this.state = {
            renders: 0,
            menuItems: []
        }

        this.miPerfectScrollbar = null;
        this.sidebar = React.createRef();
    }

    componentDidMount() {
        if (navigator.platform.indexOf("Win") > -1) {
            this.miPerfectScrollbar = new PerfectScrollbar(this.sidebar.current, {
                suppressScrollX: true,
                suppressScrollY: false
            });
        }

        if (this.props.mainMenuRoutes !== undefined) {
            this.setState({ menuItems: this.props.mainMenuRoutes });
        }
    }

    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            this.miPerfectScrollbar.destroy();
        }
    }

    render() {
        return (
            <div className="sidebar" data-color={this.props.bgColor || "black"}
                data-active-color={this.props.activeColor || "info"}>

                {this.getSidebarHeader()}

                <div className="sidebar-wrapper" ref={this.sidebar} style={{ overflowX: "hidden" }}>
                    {this.getMenu()}
                </div>
            </div>
        );
    }

    //Métodos para renderizado:
    getMenu = () => {
        return (
            <Nav>
                {this.props.mainMenuRoutes.map((route, index) => {
                    let shouldReturnRoute = true;

                    if (route.adminRequired) {
                        if (this.props.activeUser.is_admin || this.props.activeUser.is_staff) { shouldReturnRoute = true; }
                        else { shouldReturnRoute = false; }
                    }

                    if (shouldReturnRoute) {
                        return (
                            <li className={this.isThisTheActiveRoute(route.path)}
                                style={(route.bottom) ? { position: "absolute", width: "100%", bottom: 10 } : {}}
                                onClick={() => { this.setState({ renders: this.state.renders + 1 }) }}
                                key={index + "." + this.state.renders}>
                                <NavLink to={route.layout + route.path} className="nav-link" activeClassName="active"
                                    onClick={() => { localStorage.setItem("lastVisitedRoute", JSON.stringify(route.layout + route.path)) }}>
                                    <i className={route.icon} />
                                    <p>{route.name}</p>
                                </NavLink>
                            </li>
                        );
                    }
                    else { return (<React.Fragment key={index + "." + this.state.renders} />); }
                })}
            </Nav>
        );
    }

    getSidebarHeader = () => {
        return (
            <div className="logo" onClick={() => { this.props.history.push("/admin/sources"); }}
                data-tut="reactour__mainLayout.ownerLogo">
                <a href="/admin/sources" className="simple-text logo-mini"
                    onClick={(e) => { e.preventDefault(); }}>
                    <div className="logo-img">
                        <img src={ownerLogo} alt={logoAlt} />
                    </div>
                </a>

                <a href="/admin/sources" className="simple-text logo-normal"
                    style={{ textTransform: "none" }} onClick={(e) => { e.preventDefault() }}>
                    <b>{process.env.REACT_APP_CRAWLER_OWNER} </b>Crawler
                </a>
            </div>
        );
    }

    //Métodos adicionales:
    isThisTheActiveRoute(route) {
        return this.props.location.pathname.indexOf(route) > -1 ? "active" : "";
    }

}

const mapStateToProps = state => {
    return { activeUser: state.mainReducer.activeUser, };
};

export default connect(mapStateToProps)(withRouter(Sidebar));